<template>
    <div class="reputacion-section">
        <div class="reputacion-content">
            <h2 class="reputacion-title fuente-posm">
                Gestión Automática de Reputación.
            </h2>
            <p class="reputacion-text fuente-nova">
                Convierte Clientes Satisfechos en Promotores Online
                <br><br>
                Cuando un cliente califica su experiencia con 5 estrellas en tu encuesta, nuestro sistema automáticamente le envía una invitación personalizada para compartir su experiencia positiva en Google, redes sociales o TripAdvisor.
            </p>
        </div>
        <div class="reputacion-image">
            <img :src="a54" alt="Reputación">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReputacionFeedbackNew',
    data() {
        return {
            a54: require('@/assets/images/a54.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.reputacion-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.reputacion-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.reputacion-image img {
    width: 400px;
    height: auto;
}

.reputacion-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.reputacion-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.2;
    margin: 0 0 20px 0;
}

.reputacion-text {
    color: var(--color-3);
    font-size: 25px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .reputacion-title {
        font-size: 60px;
    }

    .reputacion-text {
        font-size: 22px;
    }

    .reputacion-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .reputacion-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .reputacion-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .reputacion-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .reputacion-image img {
        width: 80%;
        max-width: 320px;
    }

    .reputacion-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .reputacion-text {
        font-size: 15px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
